<template>
	<div style="float: left">
		<el-button
			v-for="(item, index) in singleList"
			:key="index"
			v-permission="item.menuCode"
			size="small"
			:menu-code="item.menuCode"
			:type="item.menuColor"
			:icon="item.menuIcon"
			:loading="item.loading"
			@click="handleCommand({ menuCode: item.menuCode, index: index, listName: 'singleList' })"
		>
			{{ item.menuName.split("-")[0] }}
		</el-button>
		<el-dropdown v-if="moreList.length > 0" style="margin-left: 10px" trigger="click" placement="top" @command="handleCommand">
			<el-button type="primary" size="small">
				更多
				<i class="el-icon-arrow-down el-icon--right"></i>
			</el-button>
			<template #dropdown>
				<el-dropdown-menu style="float: right; padding: 3px 0; margin-left: 10px">
					<el-dropdown-item
						v-for="(item, index) in moreList"
						:key="index"
						v-permission="item.menuCode"
						:icon="item.menuIcon"
						:command="beforeHandleCommand({ menuCode: item.menuCode, index: index, listName: 'moreList' })"
					>
						{{ item.menuName.split("-")[0] }}
					</el-dropdown-item>
				</el-dropdown-menu>
			</template>
		</el-dropdown>
	</div>
</template>
<script>
import permissionStore from "../../vuex/store";
export default {
	name: "BtnBox",
	props: {
		btnList: {
			type: Array,
			default: () => []
		},
		menuPath: {
			type: String,
			default: "page1-top"
		}
	},
	data() {
		return {
			showBtnList: [],
			moreList: [],
			singleList: []
		};
	},
	watch: {
		btnList: {
			handler(newVal) {
				this.hasPermission();
			}
		}
	},
	mounted() {
		this.hasPermission();
	},
	beforeUnmount() {},
	methods: {
		// 选项操作按钮
		handleCommand({ menuCode, index, listName }) {
			if (menuCode.split("-")[2] === "change") {
				this[listName][index].menuName = "保存";
				this[listName][index].menuIcon = "el-icon-check";
				this[listName][index].menuColor = "";
				this[listName][index].menuCode = "BAOCUN";
			}
			this.$emit("handle-command", menuCode);
		},
		beforeHandleCommand(command) {
			return command;
		},
		hasPermission() {
			let permissionList = Object.values(permissionStore.state.permission);
			this.showBtnList = permissionList.filter((item) => item.menuPath === this.menuPath && this.btnList.includes(item.menuCode));
			this.singleList = JSON.parse(JSON.stringify(this.showBtnList.slice(0, 4)));
			this.moreList = JSON.parse(JSON.stringify(this.showBtnList.slice(4)));
		}
	}
};
</script>
